import { render } from "./WorkEvent.vue?vue&type=template&id=0a9f9ef2"
import script from "./WorkEvent.vue?vue&type=script&lang=js"
export * from "./WorkEvent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francois/WebstormProjects/crema-manager-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__